module.exports = __webpack_public_path__ + "img/bi.bi29ab7a2.svg";